<template>
    <div class="bot-ctrl-stripe">
        <favorite-catalog-item v-if="showFav" :product_id="productId"></favorite-catalog-item>
        <!--<input v-model="quantity" data-styler disabled value="1" step="1" min="1" type="number">-->
        <b-form-input v-model="quantity" class="my_custom_input_product_quantity"
                      :disabled="!!getBasketItemById"
                      type="number" min="0" aria-label="Text input with checkbox"
        />
        <a v-if="getBasketItemById" href="javascript:;" class="btn btn-black">
            {{toOrderTitle}}
        </a>
        <a v-on:click="addItemToBasket" v-else href="javascript:;" class="btn btn-std">
            {{inBasketTitle}}
        </a>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import _u from "jsAssets/utils/index";
    import FavoriteProduct from "vueComponents/product/favorite/FavoriteCatalogItem";

    /**
     * Компонент для отображения блока " избранные товары + количество товаров + кнопка заказа"
     *
     * @vuedoc
     * @module vue:components/CatalogItemBasket
     * @exports vue:components/CatalogItemBasket
     */

    export default {
        name: "catalog-item-basket-btn",

        components: {
            'favorite-catalog-item': FavoriteProduct,
        },

        props: [
            'to_order_title','in_basket_title','product_id','show_fav'
        ],
        /**
         * Данные экземпляра компонента
         *
         * @method data
         * @property {string} inBasketTitle - Название кнопки когда товар в корзине
         * @property {string} toOrderTitle - Название кнопки когда товар отсутствует в корзине
         * @property {string|int} productId - Id товара за который отвечает компонент
         * @property {string} quantity - Количество товара
         * @property {boolean} showFav - Признак необходимости отображения кнопки избранных товаров
         */
        data() {
            return {
                inBasketTitle: this.to_order_title,
                toOrderTitle: this.in_basket_title,
                productId: this.product_id,
                quantity: "1",
                showFav: this.show_fav,
            }
        },

        computed: {
            ...mapGetters('app', [
                'user',
            ]),

            ...mapGetters('basket', [
                'basketItems',
            ]),

            /**
             *  Вычисляемое свойство которое получает список товаров в корзине
             *
             * @method getBasketItems
             */
            getBasketItems() {
                if(typeof this.basketItems !== 'undefined') {
                    return this.basketItems;
                }
            },
            /**
             *  Вычисляемое свойство которое определяет принадлежность товара к корзине и возвращает этот элемент
             *  если он находится в корзине
             *
             * @method getBasketItems
             */
            getBasketItemById() {
                if(this.basketItems && this.basketItems[this.productId] !== 'undefined') {
                    let item = this.basketItems[this.productId];
                    this.quantity = (item && item.quantity ? item.quantity : 1).toString();
                    return this.basketItems[this.productId];
                }
                return false;
            },

        },

        mounted(){
        },


        methods: {
            /**
             *  При нажатии на кнопку идет запрос к серверу на добавление товара в корзину
             *
             * @method addItemToBasket
             */
            addItemToBasket(){
                if (this.quantity > 0) {
                    this.$store.dispatch('basket/addItemToBasket', {
                        productId: this.productId,
                        quantity: this.quantity
                    });
                }
            },
        }
    }


</script>
